import * as FileDownloader from 'js-file-download';

export default class FileDownloadService {
  static downloadFromRawBinaryStream(binaryData, prefix, fileFormat) {
    FileDownloader(new Buffer(binaryData, 'binary'), prefix + fileFormat);
  }
}
